import { render, staticRenderFns } from "./LibroAutorPage.vue?vue&type=template&id=32ae4a74"
import script from "./LibroAutorPage.js?vue&type=script&lang=js&external"
export * from "./LibroAutorPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports